module.exports = __webpack_public_path__ + "img/1F970.b3f33270.svg";